import * as IoC from 'inversify';
import { registerCommand, registerQuery } from '@/app/tracking/api';
import { sectionStateCommonTrackingModule } from '../common/di'
import * as Api from '../api'
import * as Common from '../common'
import { XApiCompleteSectionCommandHandler } from './xapi-complete-section-command-handler';

const sectionStateTinCanTrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(Api.UpdateSectionStateCommandName, Common.UpdateSectionStateCommandHandler, bind);
  registerCommand(Api.AddSectionDurationCommandName, Common.AddSectionDurationCommandHandler, bind);
  registerCommand(Api.CompleteSectionCommandName, XApiCompleteSectionCommandHandler, bind);
  registerQuery(Api.QuerySectionStatesTrackingQueryName, Common.QuerySectionStatesQueryHandler, bind);
})

export const sectionStateTinCanTrackingModules = [
  sectionStateCommonTrackingModule,
  sectionStateTinCanTrackingModule
]
